import { ExploreCard } from "./crosswordGenerator";

// Sample data for testing
export const SAMPLE_CROSSWORDS: ExploreCard[] = [
  {
    uuid: "sample-1",
    title: "Monday Morning Puzzle",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["general", "puzzle"],
    timestamp: Date.now() - 86400000, // 1 day ago
    view_count: 1250
  },
  {
    uuid: "sample-2",
    title: "Weekend Brain Teaser",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["general", "weekend"],
    timestamp: Date.now() - 172800000, // 2 days ago
    view_count: 890
  },
  {
    uuid: "sample-3",
    title: "Science & Technology",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["science", "technology"],
    timestamp: Date.now() - 259200000, // 3 days ago
    view_count: 2100
  },
  {
    uuid: "sample-4",
    title: "Movie Buff Challenge",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["movies", "entertainment"],
    timestamp: Date.now() - 345600000, // 4 days ago
    view_count: 1560
  },
  {
    uuid: "sample-5",
    title: "Sports Fanatic",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["sports", "athletics"],
    timestamp: Date.now() - 432000000, // 5 days ago
    view_count: 980
  },
  {
    uuid: "sample-6",
    title: "Food & Cooking",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["food", "cooking"],
    timestamp: Date.now() - 518400000, // 6 days ago
    view_count: 1340
  },
  {
    uuid: "sample-7",
    title: "Travel Adventures",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["travel", "adventure"],
    timestamp: Date.now() - 604800000, // 7 days ago
    view_count: 890
  },
  {
    uuid: "sample-8",
    title: "Music Lovers",
    grid: [
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, false, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, true, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, false, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, true, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, false, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, true, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, false, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, true, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, false, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, true, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, false, false, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, true, true],
      [true, false, true, false, true, false, true, false, true, false, true, false, true, false, true],
      [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]
    ],
    interests: ["music", "art"],
    timestamp: Date.now() - 691200000, // 8 days ago
    view_count: 1120
  }
];

// Utility functions for sample data
export const getSampleCrosswords = (filter: 'popular' | 'recent', limit: number = 12): ExploreCard[] => {
  const sortedSamples = [...SAMPLE_CROSSWORDS];
  
  if (filter === 'recent') {
    // Sort by timestamp (most recent first)
    sortedSamples.sort((a, b) => b.timestamp - a.timestamp);
  } else {
    // Sort by view count (most popular first)
    sortedSamples.sort((a, b) => b.view_count - a.view_count);
  }
  
  return sortedSamples.slice(0, limit);
};

export const getMoreSampleCrosswords = (currentCount: number, limit: number = 4): ExploreCard[] => {
  return SAMPLE_CROSSWORDS.slice(currentCount, currentCount + limit);
};

export const simulateApiDelay = (callback: () => void, delay: number = 1000): void => {
  setTimeout(callback, delay);
}; 